/* eslint-disable camelcase */
import React from "react";
import { useTranslation } from "ceco-polyglot";
import { MoreVertical, Edit, Delete } from "ceicons";
import Pill from "../Pill";
import IngredientRecipeModal from "../../modals/IngredientRecipeModal";
import { IngredientRecipeDeleteModal } from "../../modals/IngredientRecipeDeleteModal";
import DropDownButton from "../../DropDownButton";

export default function IngredientsList({
  recipeName,
  ingredients,
  recipeId,
  allIngredients,
  allUnitMeasure,
  refetchData,
}) {
  const t = useTranslation();

  return (
    <div className="pills ingredients-list">
      {ingredients &&
        ingredients.map((ingredient, i) => {
          return (
            <div className={`pill`} key={i}>
              <span className="number">{i + 1}</span>
              <span className="text">{ingredient.ingredient.name}</span>

              <DropDownButton icon={<MoreVertical />}>
                <IngredientRecipeModal
                  refetchData={refetchData}
                  recipeId={recipeId}
                  edit
                  ingredient={ingredient}
                  allIngredients={allIngredients}
                  allUnitMeasure={allUnitMeasure}
                  trigger={
                    <div>
                      <Edit />
                      <p>{t("popup.edit")}</p>
                    </div>
                  }
                />

                <IngredientRecipeDeleteModal
                  recipeName={recipeName}
                  recipeId={recipeId}
                  refetchData={refetchData}
                  edit
                  ingredient={ingredient}
                  allIngredients={allIngredients}
                  allUnitMeasure={allUnitMeasure}
                  trigger={
                    <div className="delete-modal">
                      <Delete />
                      <p>{t("popup.remove")}</p>
                    </div>
                  }
                />
              </DropDownButton>
            </div>
          );
        })}

      <IngredientRecipeModal
        recipeId={recipeId}
        refetchData={refetchData}
        allIngredients={allIngredients}
        allUnitMeasure={allUnitMeasure}
        trigger={
          <span>
            <Pill newItem text={t("pill.addIngredient")} />
          </span>
        }
      />
    </div>
  );
}
